import React, { useCallback, useEffect, useMemo } from "react";
import { createUseStyles } from "react-jss";
import { motion, useAnimation } from "framer-motion";
// import useInterval from "hooks/useInterval";
import NumberFormat from "react-number-format";
import logoGray from "logo_gray.svg";
import { colors } from "helpers/colors";
import { IOffer } from "types/IOffer";
import { POPUP_NEXT_DURATION, POPUP_NEXT_INTERVAL } from "helpers/const";

interface INextPopup {
  offers: IOffer[];
}

export default function NextPopup(props: INextPopup) {
  const { offers } = props;
  const classes = useStyles();
  const popupNextAnim = useAnimation();

  const animatePopupNext = useCallback(async () => {
    await popupNextAnim.start({
      x: [150, -20, 0],
      opacity: [0, 1],
      transition: {
        type: "spring",
        duration: 1,
      },
    });
    await popupNextAnim.start({
      x: [0, 500],
      opacity: [1, 0],
      transition: {
        delay: POPUP_NEXT_DURATION / 1000,
        type: "spring",
        duration: 1,
      },
    });
  }, [popupNextAnim]);

  // useInterval(async () => {
  //   await animatePopupNext();
  // }, POPUP_NEXT_INTERVAL);

  const sleep = useCallback(
    async (ms: number) => new Promise((resolve) => setTimeout(resolve, ms)),
    []
  );

  useEffect(() => {
    (async function () {
      await sleep(POPUP_NEXT_INTERVAL);
      await animatePopupNext();
    })();
  }, [animatePopupNext, sleep]);

  const nextOfferItems = useMemo(() => {
    if (!offers) {
      return [];
    }

    const items = offers.map((nextOffer: any, index: number) => {
      let imagePath = logoGray;
      if (nextOffer.photos?.[0]?.file.path.indexOf("http") === 0) {
        imagePath = nextOffer.photos?.[0]?.file.path;
      }
      return (
        <div className={"item"} key={`offers-${nextOffer.id}-${index}`}>
          <div className={"price-container"}>
            <img src={imagePath} alt="" width={250} />
            <div className={"price"}>
              <NumberFormat
                value={nextOffer.price}
                displayType={"text"}
                thousandSeparator={" "}
                suffix={"€"}
              />
            </div>
          </div>
          <p>
            {nextOffer.city}
            <br />
            {nextOffer.propertyType}
          </p>
        </div>
      );
    });

    return items.slice(0, 4);
  }, [offers]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={popupNextAnim}
      className={classes.popupNextContainer}
    >
      <div className={classes.popupNextTitleContainer}>
        <span>À suivre...</span>
      </div>
      <div className={classes.popupNextContentContainer}>{nextOfferItems}</div>
    </motion.div>
  );
}

const useStyles = createUseStyles({
  popupNextContainer: {
    zIndex: 100,
    position: "absolute",
    top: 250,
    right: 0,
    backgroundColor: "white",
    boxShadow:
      "4px 4px 8px lightgrey, -4px 4px 8px lightgrey, -4px -4px 8px lightgrey",
    padding: 20,
    "& .price": {
      position: "absolute",
      bottom: 0,
      right: 0,
    },
  },
  popupNextContentContainer: {
    width: 520,
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    padding: 10,
    textAlign: "center",
    fontSize: 22,
    "& .item": {
      paddingTop: 10,
      "& p:first-letter": {
        textTransform: "capitalize",
      },
      "& .price-container": {
        position: "relative",
        "& .price": {
          backgroundColor: colors.imko,
          color: "white",
          padding: 10,
          fontWeight: "bold",
        },
      },
    },
  },
  popupNextTitleContainer: {
    position: "absolute",
    top: -60,
    right: 500,
    backgroundColor: colors.imko,
    fontSize: 32,
    color: "white",
    fontWeight: 600,
    whiteSpace: "nowrap",
    padding: 15,
    boxShadow: `4px 4px 8px ${colors.imko}, 0px 0px 8px ${colors.imko}`,
  },
});
